import React from 'react';
import CrearOrdenCompra from '../../../components/insumos/orden_compra/CrearOrdenCompra';

const OrdenCompraPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <CrearOrdenCompra />
    </div>
  );
};

export default OrdenCompraPage;